import React, { useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import { useAuthState } from '../../../Context';
import { loginUser } from '../../../Context/actions/authActions';

const ssoAuth = () => {
    const location = useLocation();
    const history = useHistory();
    const { authDispatch } = useAuthState();
    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const token = queryParams.get('token');
        const modelTypeID = queryParams.get('modelTypeID');
        const entityID = queryParams.get('entityID');
        if (!token || !modelTypeID || !entityID) {
            history.push('/login');
            return;
        }

        (async () => {
            try {
                const response = await loginUser(authDispatch, { token, modelTypeID, entityID }, true);
                if (response && response.user) {
                    // Persist the selected portal's scope. On a universal login host
                    // (localhost, driverportal.tbndrives.com) the hostname can't resolve a single
                    // entity, so this is the only place the scope gets set for the session.
                    localStorage.setItem('dp_modelTypeID', String(modelTypeID));
                    localStorage.setItem('dp_entityID', String(entityID));
                    history.push('/driver/assignments'); // or home page
                } else {
                    history.push('/login'); // fallback
                }
            } catch (error) {
                console.error(error);
                history.push('/login');
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="driver-login-redirect-page">
            <div
                className="loading-wrapper text-center d-flex flex-column justify-content-center align-items-center"
                style={{ height: '100vh' }}
            >
                <Spinner animation="border" variant="primary" />
                <h4 className="mt-4">Logging you in securely...</h4>
                <p className="text-muted">Please wait while we verify your session.</p>
            </div>
        </div>
    );
};

export default ssoAuth;
